import HomePage from '@/components/home-page'
//import Login from 'components/login'

export const routes = [

    { name: 'home', path: '/', component: HomePage, display: 'Home', style: 'glyphicon glyphicon-home'  },
    //{ name: 'login', path: '/login', component: Login, display: 'Login' },
]
